<template>
  <div>
    <div>
      <span class="xbed-sub-title">清洁单管理</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>麗家会</BreadcrumbItem>
        <BreadcrumbItem>清洁单管理</BreadcrumbItem>
      </Breadcrumb>
    </div>
      <!-- <Tabs class="tabs">
        <TabPane label="清洁单信息列表" name="orderList" ref="orderList"> -->
          <section class="refresh-order">
            <span>今天预计发单数：<span>{{todayData.prepareCount}}</span></span>
            <span>今天已发单数：<span>{{todayData.createCount}}</span></span>
            <span>今天被抢单数：<span>{{todayData.orderCount}}</span></span>
            <span>今天清洁完成单数：<span>{{todayData.leaveCount}}</span></span>
            <span>已审核单数：<span>{{todayData.checkCount}}</span></span>
            <Button type="primary" @click="refreshTodayData">刷新</Button>
          </section>
          <Form @submit.native.prevent="preventSubmit" ref="orderListForm" :rules="orderList.rules" :model="orderList" inline>
            <Row>
              <FormItem  label="创建日期：" prop="createDate" :label-width="84">
                <DatePicker v-model="orderList.createDate" @on-change="dateRange => {changeDateRange(dateRange, 'createDate')}" :options="disabledDateOptions" type="daterange" placeholder="选择日期" style="width: 234px"></DatePicker>
              </FormItem>
              <FormItem  label="服务日期：" prop="serviceDate" :label-width="84">
                <DatePicker v-model="orderList.serviceDate" @on-change="dateRange => {changeDateRange(dateRange, 'serviceDate')}" type="daterange" placeholder="选择日期" style="width: 234px"></DatePicker>
              </FormItem>
              <FormItem  label="进度：" prop="orderStatus" :label-width="80">
                <Select v-model="orderList.orderStatus" filterable>
                  <Option value='S00'>全部</Option>
                  <Option v-for="(status, index) in orderStatusArr" :key="status" :value="index">{{status}}</Option>
                </Select>
              </FormItem>
              <FormItem  label="清洁类型：" prop="cleanTypeId" :label-width="84">
                <Select v-model="orderList.cleanTypeId" filterable>
                  <Option value='S00'>全部</Option>
                  <Option v-for="(cleanType, index) in cleanTypeList" :key="`${cleanType.id}-${index}`" :value="cleanType.id">{{cleanType.name}}</Option>
                </Select>
              </FormItem>
            </Row>
            <Row>
              <FormItem  label="城市：" prop="city" :label-width="84">
                <Select v-model="orderList.city" style="width: 200px;" placeholder="请选择" filterable>
                  <Option value='S00'>全部</Option>
                  <Option v-for="(city, index) in cityList" :key="index" :value="city">{{city}}</Option>
                </Select>
              </FormItem>
              <!-- <FormItem  label="热点：" prop="hotspotId" :label-width="80">
                <Select v-model="orderList.hotspotId" style="width: 200px;" placeholder="请选择" filterable>
                  <Option value='S00'>全部</Option>
                  <Option v-for="(hotspot, index) in hotspots" :key="`${hotspot.sourceId}-${index}`" :value="hotspot.sourceId">{{`${hotspot.sourceId}_${hotspot.sourceName}`}}</Option>
                </Select>
              </FormItem> -->
              <FormItem  label="门店：" prop="chainId" :label-width="80">
                <Select v-model="orderList.chainId" style="width: 200px;" placeholder="请选择" filterable>
                  <Option value='S00'>全部</Option>
                  <Option v-for="(chain, index) in chains" :key="`${chain.sourceId}-${index}`" :value="chain.sourceId">{{`${chain.sourceId}_${chain.sourceName}`}}</Option>
                </Select>
              </FormItem>
              <FormItem label="房号：" prop="roomNo" :label-width="80">
                <Input v-model="orderList.roomNo"></Input>
              </FormItem>
            </Row>
            <Row>
              <FormItem  label="清洁单来源：" prop="cleanSource" :label-width="100">
                <Select v-model="orderList.cleanSource" filterable>
                  <Option :value='-1'>全部</Option>
                  <Option v-for="source in sourceArrData" v-bind:value="source.value" :key="source.name">{{source.name}}</Option>

                </Select>
              </FormItem>
              <FormItem  label="清洁单状态：" prop="orderType" :label-width="100">
                <Select v-model="orderList.orderType" filterable>
                  <Option :value='0'>全部</Option>
                  <Option :value='1'>正常单</Option>
                  <Option :value='2'>指派单</Option>
                  <Option :value='3'>人工结单</Option>
                  <Option :value='4'>取消单</Option>
                  <Option :value='5'>自动派单</Option>
                </Select>
              </FormItem>
              <FormItem  label="优先单状态：" prop="priority" :label-width="100">
                <Select v-model="orderList.priority" filterable>
                  <Option :value='3'>全部</Option>
                  <Option :value='1'>是</Option>
                  <Option :value='0'>否</Option>
                </Select>
              </FormItem>
              <FormItem label="xbed订单号：" prop="xbedOrderNo" :label-width="120">
                <Input type="text" v-model="orderList.xbedOrderNo" :maxlength="255"></Input>
              </FormItem>
              <FormItem label="清洁单号：" prop="orderNo" :label-width="90">
                <Input v-model="orderList.orderNo"></Input>
              </FormItem>
            </Row>
            <FormItem label="接单人：" prop="receiver" :label-width="80">
              <Input v-model="orderList.receiver" placeholder="姓名/手机号"></Input>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="queryCleanOrderListWithKeyword">查询</Button>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="openCreateOrderModal">人工建单</Button>
            </FormItem>
          </Form>
          <Content>
          <Table stripe :loading="orderList.loading" :columns="orderList.columns" :data="orderList.data"></Table>
          <div style="margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="orderList.count" :current="orderList.page" :page-size="orderList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
          </div>
          </Content>
        <!-- </TabPane>
      </Tabs> -->
    <Modal v-model="createOrderModal.display" title="人工建单" ref="createOrderModal" :loading="true" @on-ok="preCreateOrder">
      <Form :model="createOrderModal" ref="createOrderModalForm" :rules="createOrderModal.rules" :label-width="128">
        <FormItem label="门店：" prop="chainId">
          <Select v-model="createOrderModal.chainId" style="width: 320px;" @on-change="changeChainForModal" transfer filterable>
            <Option v-for="(chain, index) in chainListForModal" :key="`${chain.chainId}-${index}`" :value="chain.chainId">{{chain.chainName}}</Option>
          </Select>
        </FormItem>

        <FormItem label="房间：" prop="roomId">
          <Select v-model="createOrderModal.roomId" @on-change="findItemType" style="width: 320px;" transfer filterable>
            <Option v-for="(room, index) in roomListForModal" :key="`${room.roomId}-${index}`" :value="room.roomId">{{room.roomName}}</Option>
          </Select>
        </FormItem>

        <FormItem label="触发方案：" prop="plan">
          <Select v-model="createOrderModal.plan" @on-change="findItemType" filterable transfer>
            <Option :value="1">在住清洁</Option>
            <Option :value="2">退房清洁</Option>
            <Option :value="3">停用单清洁</Option>
            <Option :value="4">开荒清洁</Option>
            <Option :value="9">特殊人工单</Option>
          </Select>
        </FormItem>

        <FormItem label="人工单类型：" prop="cleanTypeId" v-if="createOrderModal.plan==9">
          <Select v-model="createOrderModal.cleanTypeId" @on-change="selectCleanTypeFn" filterable transfer>
            <Option :value="19">物品补充单</Option>
            <Option :value="15">维修单</Option>
          </Select>
        </FormItem>

        <FormItem v-if="Object.keys(itemDetailGroup).length > 0" label="选择物品：" prop="goods">
          <checkbox-group v-model="createOrderModal.goods">
            <checkbox v-for="(item, key) in itemDetailGroup" :key="key" :disabled="createOrderModal.itemType === 1" :label="key">{{ item }}</checkbox>
          </checkbox-group>
          <span class="tips-info">*不选择则表示该类型不需要更换补充物品</span>
        </FormItem>

        <FormItem  label="服务时间：" prop="serviceDate">
          <DatePicker v-model="createOrderModal.serviceDate" @on-change="date => {changeDate(date, 'serviceDate')}" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="选择日期" style="width: 234px" :options="dateOptions" :clearable="false" :editable="false"></DatePicker>
        </FormItem>

        <FormItem v-if="createOrderModal.plan<3||(createOrderModal.plan==9&&createOrderModal.cleanTypeId==19)" label="xbed订单编号：" prop="xbedOrderNo">
          <Input v-model="createOrderModal.xbedOrderNo"></Input>
        </FormItem>

        <FormItem v-if="createOrderModal.plan<3||(createOrderModal.plan==9&&createOrderModal.cleanTypeId==19)" label="xbed入住单号：" prop="xbedCheckinId">
          <Input v-model="createOrderModal.xbedCheckinId"></Input>
        </FormItem>

        <FormItem label="建单原因" prop="orderRemark">
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="100" v-model="createOrderModal.orderRemark"></Input>
        </FormItem>

      </Form>
    </Modal>
    <!-- 指派清洁单 -->
    <account-table :assignOrderModal='assignOrderModal' @chooseCleaner='chooseCleaner' @preAssignOrder='preAssignOrder' @changeSelected="changeAssignOrderAccount"></account-table>

    <Modal v-model="assignRefuseOrderModal.display" ref="assignRefuseOrderModal" title="选择热点工作人员" :loading="true" ok-text="指派清洁单" :width="900" @on-ok="preAssignRefuseOrder">
      <account-table :data="assignRefuseOrderModal.data" :loading="assignRefuseOrderModal.loading" @changeSelected="changeAssignRefuseOrderAccount"></account-table>
    </Modal>

    <Modal v-model="orderMessageListModal.display" ref="orderMessageListModal" title="查看日志" :width="1000">
      <order-logs :logsData="orderMessageListModal.logsData"></order-logs>
      <div slot="footer">
        <Button @click="closeOrderMessageListModal">关闭</Button>
      </div>
    </Modal>

    <!-- 查看留言modal -->
    <Modal v-model="orderLeaveCommentsModal.display" ref="orderMessageListModal" title="查看留言" :width="1000">
      <leave-comments :data="orderLeaveCommentsModal.data"></leave-comments>
      <div slot="footer">
        <Button @click="closeOrderLeaveCommentsModal">关闭</Button>
      </div>
    </Modal>

    <!-- 取消清洁单modal -->
    <Modal v-model="cancelOrderModal.display" ref="cancelOrderModal" title="取消清洁单" :loading="true" :width="1000" @on-ok="preCancelCleanOrder">
      <Form @submit.native.prevent="preventSubmit" :model="cancelOrderModal" ref="cancelOrderModalForm" :rules="cancelOrderModal.rules" >
        <FormItem  label="清洁单ID：" prop="id" :label-width="120">
          <p style="font-size: 14px;">{{cancelOrderModal.id}}</p>
        </FormItem>
        <FormItem  label="门店：" prop="chain" :label-width="120">
          <p style="font-size: 14px;">{{cancelOrderModal.chainName}}</p>
        </FormItem>
        <FormItem  label="房号：" prop="roomNo" :label-width="120">
          <p style="font-size: 14px;">{{cancelOrderModal.roomNo}}</p>
        </FormItem>
        <FormItem  label="取消原因类型：" prop="city" :label-width="120">
          <Select v-model="cancelOrderModal.reasonType" style="width: 200px;" @on-change="changeReason" label-in-value filterable>
            <Option :value='1'>客户续住，不需清洁</Option>
            <Option :value='2'>客户换房，不需清洁</Option>
            <Option :value='3'>管家同意扣罚，申请取消</Option>
            <Option :value='4'>其他</Option>
          </Select>
        </FormItem>
        <FormItem label="取消原因：" prop="reason" :label-width="120">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="cancelOrderModal.reason" placeholder="必填"></Input>
        </FormItem>
        
        <!-- 新增更新房态选项 -->
        <FormItem label="更新当前房态">
          <Checkbox v-model="cancelOrderModal.updateRoomStatus">勾选后即改为干净房。请务必查看到有客户原房间续住订单，才能勾选更新房态。</Checkbox>
        </FormItem>
      </Form>
    </Modal>

    <!-- 结束清洁单——需要填写更换/补充物品时先提交补充的物品再结束清洁单 -->
    <Modal v-model="overCleanOrderModal.display" ref="overCleanOrderModal" title="结束清洁单" :loading="true" :width="800" @on-ok="submitOverCleanOrder" v-if='isAddNum'>
      <table class="cleanTable">
        <tr class="top">
          <td class="col-style">
              <h4 class="title-style">物品</h4>
          </td>
          <td class="col-style">
              <h4 class="title-style">属性</h4>
          </td>
          <td class="col-style">
              <h4 class="title-style">补充/更换数量</h4>
          </td>
        </tr>
        <tr class="top" v-for="(good,key) in goodsAdd" :key="key">
          <td class="col-style">
              <p class="title-style">{{good.goodsName}}</p>
          </td>
          <td class="col-style">
              <p class="title-style">{{`${good.goodsAttribute == 1 ? '易耗品' : '布草'}`}}</p>
          </td>
          <td class="col-style">
            <InputNumber type='number' :min="0" v-model="good.goodsNum"></InputNumber>
          </td>
        </tr>
        <!-- 补充物品为空 -->
        <tr class="top" style="background: #fff;" v-show="!(typeof(goodsAdd) === 'object' && goodsAdd.length > 0)">
          <td class="col-style" colspan="3">
            <Spin style="width:50px;margin:0 auto;z-index:99;" v-show="isSpin"></Spin>
            <span>暂无数据</span>
          </td>
        </tr>
      </table>
      <div class="tipsMessage">
        <p>确定结束清洁单 <span>{{overCleanOrderModal.tips}}</span> 吗？</p>
        <p>请谨慎操作</p>
        <Form ref="overCleanOrderModalForm" :rules="overCleanOrderModal.rules" :model='overCleanOrderModal' inline>
          <FormItem prop="reason">
            <Input style="width:650px;" type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="overCleanOrderModal.reason" placeholder="请输入结束清洁单原因（必填）" :maxlength="500"></Input>
          </FormItem>
        </Form>
      </div>
    </Modal>
    <!-- 结束清洁单——不需要补充/更换物品时直接结束清洁单 -->
    <Modal v-model="overCleanOrderModal.display" ref="overCleanOrderModal" title="结束清洁单" :loading="true" :width="800" @on-ok="preOverCleanOrder" v-else>
      <p>确定结束清洁单 <span>{{overCleanOrderModal.tips}}</span> 吗？</p>
      <p>请谨慎操作</p>
      <Form ref="overCleanOrderModalForm" :rules="overCleanOrderModal.rules" :model='overCleanOrderModal' inline>
        <FormItem prop="reason">
          <Input style="width:650px" type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="overCleanOrderModal.reason" placeholder="请输入结束清洁单原因（必填）" :maxlength="500"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 人工结束清洁单原因 -->
    <Modal v-model="overCleanReasonModal.display" ref="overCleanReason" title="人工结单原因" :width="500">
      <Input v-model="overCleanReasonModal.overReason" disabled  type="textarea" :autosize="{minRows: 5,maxRows: 10}"></Input>
      <div slot="footer">
        <Button @click="closeOverCleanReasonModal">关闭</Button>
      </div>
    </Modal>

    <Modal v-model="checkReportModal.display" ref="checkReportModal" title="核查情况" :width="1000">
      <check-report :data="checkReportModal.data"></check-report>
      <div slot="footer">
        <Button @click="closeCheckReportModal">关闭</Button>
      </div>
    </Modal>

    <Modal v-model="orderImgsModal.display" ref="checkReportModal" title="照片" :width="1000">
      <order-imgs ref="orderImgs" :data="orderImgsModal.imgs"></order-imgs>
      <div slot="footer">
        <Button @click="closeOrderImgsModal">关闭</Button>
      </div>
    </Modal>

    <Modal v-model="replaceGoodsModal.display" ref="checkReportModal" title="物品补充更换" :width="640">
      <Table stripe :columns="replaceGoodsModal.columns" :data="replaceGoodsModal.data"></Table>
      <div slot="footer">
        <Button @click="closeReplaceGoodsModal">关闭</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import Moment from "moment"
import Utils from "@/utils";
import API from "@/api";
import {STORE_KEY} from "../../../constants"

import OrderLogs from './order-logs'
import LeaveComments from './leave-comments'
import CheckReport from './check-report'
import AccountTable from './account-table'
import OrderImgs from './order-img'

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });

    this.refreshTodayData();
    this.querySelectList();
    this.queryCleanTypeList();

    this.queryPnsFeeCostList();

    this.queryChainListForModal();

    this.queryCleanOrderList();
  },
  data() {
    const validateCreateOrder = {
      chainId: (rule, value, callback) => {
        if (!this.createOrderModal.chainId) {
          callback(new Error('请选择门店'))
        } else {
          callback();
        }
      },
      roomId: (rule, value, callback) => {
        if (!this.createOrderModal.roomId) {
          callback(new Error('请选择房间'));
        } else {
          callback();
        }
      },
      plan: (rule, value, callback) => {
        if (!this.createOrderModal.plan) {
          callback(new Error('请选择触发方案'));
        } else {
          callback();
        }
      },
      cleanTypeId: (rule, value, callback) => {
        if (!this.createOrderModal.cleanTypeId) {
          callback(new Error('请选择人工单类型'));
        } else {
          callback();
        }
      },
      serviceDate: (rule, value, callback) => {
        if (!this.createOrderModal.serviceDate) {
          callback(new Error('请选择日期'));
        } else {
          callback();
        }
      },
      orderRemark: (rule, value, callback) => {
        let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;  
        if(!this.createOrderModal.orderRemark || this.createOrderModal.orderRemark.trim().length<1){
          callback(new Error('建单原因不能为空'));
        }else if(emojiReg.test(this.createOrderModal.orderRemark)) {
          callback(new Error('系统暂不支持表情'));
        }else {
          callback();
        }
      }
    }

    const validateOrderList = {
      orderNo: (rule, value, callback) => {
        if (this.orderList.orderNo && isNaN(this.orderList.orderNo)) {
          callback(new Error('请输入正确的清洁单号'));
        } else if (this.orderList.orderNo && this.orderList.orderNo.length > 255) {
          
          callback(new Error('清洁单号不能超过255字'));
        } else {
          callback();
        }
      },
      roomNo: (rule, value, callback) => {
        if (this.orderList.roomNo && isNaN(this.orderList.roomNo)) {
          callback(new Error('请输入正确的房号'));
        } else if (this.orderList.roomNo && this.orderList.roomNo.length > 255) {
          callback(new Error('房号不能超过255字'));
        } else {
          callback();
        }
      },
      xbedOrderNo: (rule, value, callback) => {
        if (this.orderList.xbedOrderNo && isNaN(this.orderList.xbedOrderNo)) {
          callback(new Error('请输入正确的xbed单号'));
        } else if (this.orderList.xbedOrderNo && this.orderList.xbedOrderNo.length > 255) {
          
          callback(new Error('xbed单号不能超过255字'));
        } else {
          callback();
        }
      },
    }
    return {
      isSpin:false,//是否显示加载
      currentOrder: null,
      todayData: {
        checkCount: 0,
        createCount: 0,
        leaveCount: 0,
        orderCount: 0,
        prepareCount: 0
      },
      // 补充
      goodsAdd:[],
      // 是否需要补充
      isAddNum:false,
      hasEmoji: false,
      sourceArrData: Utils.cleanSources(null),
      orderStatusArr: ['未接单', '已接单', '到达房间', '开门成功', '清洁完成', '离房成功', '已核查'],
      itemDetailGroup: {},
      pnsFeeCostList: [],
      cleanTypeList: [],
      cityList: [],
      chainList: [],
      hotspotList: [],
      chainListForModal: [],
      roomListForModal: [],
      orderList: {
        createDate: [
          Moment().subtract(6, 'day').format('YYYY-MM-DD'),
          Moment().format('YYYY-MM-DD')
        ],
        serviceDate: [],
        schedule: '',
        cleanTypeId: 'S00',
        orderStatus: 'S00',
        city: 'S00',
        hotspotId: 'S00',
        chainId: 'S00',
        orderType: 0,
        cleanSource:-1,
        xbedOrderNo: '',
        orderNo: '',
        receiver: '',
        priority: 3,
        loading: false,
        columns: [
          {
            title: "清洁单号",
            key: "orderNo",
            align: "center",
            width: 260,
          },
          {
            title: "xbed订单号",
            key: "xbedOrderNo",
            align: "center",
            width: 260,
          },
          {
            title: "入住单号",
            key: "xbedCheckinId",
            align: "center",
            width: 150,
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
            width: 130,
            render: (h, params) => {
              const createDate = params.row.createDate ? Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss') : '';

              return h("div", {}, createDate);
            }
          },
          {
            title: "清洁单来源",
            key: "cleanSource",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h("div", {}, Utils.cleanSources(params.row.cleanSource));
            }
          },
          {
            title: "下单人",
            key: "createName",
            align: "center",
            width: 150,
          },
          {
            title: "服务时间",
            key: "serviceDate",
            align: "center",
            width: 130,
            render: (h, params) => {
              const serviceDate = params.row.serviceDate ? Moment(params.row.serviceDate).format('YYYY-MM-DD HH:mm:ss') : '';

              return h("div", {}, serviceDate);
            }
          },
          {
            title: "门店",
            key: "chainName",
            align: "center",
            width: 150,
            render: (h, params) => {
              let chain = ''
              if(params.row.chainId && params.row.chainName) {
                  chain = `${params.row.chainId}_${params.row.chainName}`;
              }else{
                  chain = ''
              }
              return h("div", {}, chain);
            }
          },
          {
            title: "房间",
            key: "roomName",
            align: "center",
            width: 150,
            render: (h, params) => {
              const chain = `${params.row.roomId}_${params.row.roomName}`;

              return h("div", {}, chain);
            }
          },
          {
            title: "清洁类型",
            key: "cleanTypeName",
            align: "center",
            width: 120,
          },
          {
            title: "物品要求",
            key: "id",
            align: "center",
            width: 150,
            render: (h, params) => {
              const itemDetailStrArr = ['更换床品', '更换毛巾', '补充易耗品'];

              let renderItemDetailStrArr = []
              const itemDetailArr = params.row.itemDetail ? params.row.itemDetail.split(',') : [];
              for (let i = 0; i < itemDetailArr.length; i++) {
                if(itemDetailArr[i] == '1' || itemDetailArr[i] == '2' || itemDetailArr[i] == '3'){
                  renderItemDetailStrArr.push(itemDetailStrArr[parseInt(itemDetailArr[i]) - 1]);
                }else{
                  renderItemDetailStrArr.push(itemDetailArr[i])
                }
              }
              return h("div", {}, renderItemDetailStrArr.length > 0 ? renderItemDetailStrArr.join(',') : '不更换布草耗品')
            }
          },
          {
            title: "进度",
            align: "center",
            width: 120,
            render: (h, params) => {
              const orderStatusStr = ['未接单', '已接单', '到达房间', '开门成功', '清洁完成', '离房成功', '已核查', '已取消'];

              return h("div", {}, orderStatusStr[params.row.orderStatus]);
            }
          },
          {
            title: "接单日志",
            align: "center",
            width: 90,
            render: (h, params) => {
              
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.openOrderMessageListModal(params.row.id)
                      }
                    }
                  },
                  "查看"
                )
              ]);
            }
          },
          {
            title: "核查情况",
            align: "center",
            width: 90,
            render: (h, params) => {
              const waitCheckedDisplay = params.row.isDamageGood === 0 ? 'block' : 'none';
              const checkedDisplay = params.row.isDamageGood !== 0 ? 'inline-block' : 'none';
              const checkedBtnType = params.row.isDamageGood === 2 ? 'primary' : 'error'
              const checkedBtnTxt = params.row.isDamageGood === 2 ? '核查无误' : '有缺损';

              return h("div", [
                h(
                  "div",
                  {
                    style: {
                      margin: "5px",
                      display: waitCheckedDisplay,
                    },
                  },
                  "待审查"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: checkedBtnType,
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: checkedDisplay
                    },
                    on: {
                      click: () => {
                        this.openCheckReportModal(params.row.id);
                      }
                    }
                  },
                  checkedBtnTxt
                )
              ]);
            }
          },
          {
            title: "补充更换",
            align: "center",
            width: 90,
            render: (h, params) => {
              
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.openReplaceGoodsModal(params.row.id)
                      }
                    }
                  },
                  "查看"
                )
              ]);
            }
          },
          {
            title: "查看照片",
            key: "id",
            align: "center",
            width: 90,
            render: (h, params) => {
              const hasNotPicDisplay = params.row.isHavePicture === 0 ? 'block' : 'none';
              const hasPicDisplay = params.row.isHavePicture === 1 ? 'inline-block' : 'none';

              return h("div", [
                h(
                  "div",
                  {
                    style: {
                      margin: "5px",
                      display: hasNotPicDisplay,
                    },
                  },
                  "无照片"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: hasPicDisplay
                    },
                    on: {
                      click: () => {
                        this.openOrderImgsModal({
                          id: params.row.id
                        })
                      }
                    }
                  },
                  "查看"
                )
              ]);
            }
          },
          {
            title: "接单人",
            key: "cleanerName",
            align: "center",
            width: 150,
            render: (h, params) => {
              const cleanerName = params.row.cleanerName ? params.row.cleanerName : '';
              const phone = params.row.cleanerAccount ? params.row.cleanerAccount : '';

              return h("div", [
                h("p", {}, cleanerName),
                h("p", {}, phone)
              ]);
            }
          },
          {
            title: "清洁薪酬（元）",
            key: "id",
            align: "center",
            width: 120,
            render: (h, params) => {

              return h("div", [
                h("p", {}, `应付：${(params.row.price / 100).toFixed(2)}`),
                h("p", {}, `核实：${(params.row.checkPrice / 100).toFixed(2)}`)
              ]);
            }
          },
          {
            title: "做单留言",
            key: "id",
            align: "center",
            width: 90,
            render: (h, params) => {
              const hasNotMsgDisplay = params.row.isHaveMessage === 0 ? 'block' : 'none';
              const hasMsgDisplay = params.row.isHaveMessage === 1 ? 'inline-block' : 'none';

              return h("div", [
                h(
                  "div",
                  {
                    style: {
                      margin: "5px",
                      display: hasNotMsgDisplay,
                    },
                  },
                  "无留言"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: hasMsgDisplay
                    },
                    on: {
                      click: () => {
                        this.openOrderLeaveCommentsModal(params.row.id)
                      }
                    }
                  },
                  "查看"
                )
              ]);
            }
          },
          {
            title: "单性质",
            key: "id",
            align: "center",
            width: 90,
            render: (h, params) => {
              const orderNatureStrArr = ['预约单', '即时单', '紧急单'];

              return h("div", {}, orderNatureStrArr[params.row.orderNature - 1]);
            }
          },
          {
            title: "清洁单状态",
            key: "id",
            align: "center",
            width: 100,
            render: (h, params) => {
              const orderTypeArr = ['', '正常单', '指派单', '人工结单', '已取消', '自动派单'];

              let orderTypeText = orderTypeArr[params.row.orderType];

              if (params.row.orderType === 5) {
                const autoOrderStatus = ['未接', '已接', '拒接', '未接', '未接'];

                orderTypeText += ` - ${autoOrderStatus[params.row.autoOrderStatus]}`;
              }

              return h("div", {}, orderTypeText);
            }
          },
          {
            title: "优先单状态",
            align: "center",
            width: 90,
            render: (h, params) => {
              if(params.row.priority == 1){
                return h('div', [
                  h('p', {
                    style: {
                      textAlign: "center"
                    }
                  }, '是'),
                  h('p', {
                    style: {
                      textAlign: "center"
                    }
                  }, params.row.isOverDate&&Moment(params.row.isOverDate).format('YYYY-MM-DD HH:mm:ss'))
                ])
              }else {
                return h('div', {}, '不是')
              }
            }
          },
          {
            title:'人工结单原因',
            align:"center",
            width:150,
            render:(h,params)=>{
              return h('div',[
                h('Button',{
                  props:{
                    type:'primary',
                    size:'small'
                  },
                  on:{
                    click:()=>{
                      this.overCleanReasonModal.overReason = params.row.finishReason
                      this.overCleanReasonModal.display = true;
                    }
                  }
                },
                '查看'
                )
              ])
            }
          },
          {
            title: "操作",
            align: "center",
            width: 300,
            render: (h, params) => {
              const assignOrderDisplay = params.row.orderStatus == 0 && params.row.orderType == 1 ? 'inline-block' : 'none';
              const assignRefuseOrderDisplay = params.row.orderType == 5 && params.row.autoOrderStatus > 1 ? 'inline-block' : 'none';
              const finishedOrderDisplay = params.row.orderStatus < 5 && params.row.orderStatus > 0 && ( params.row.orderType < 3 || params.row.orderType == 5 ) ? 'inline-block' : 'none';
              const cancelOrderDisplay = params.row.orderStatus < 5 && ( params.row.orderType == 1 || ( params.row.orderStatus > 0 && params.row.orderType == 2 ) || ( params.row.orderType == 5 && params.row.autoOrderStatus > 0 ) ) ? 'inline-block' : 'none';
              const openElecDisplay = params.row.orderStatus >= 1 && params.row.orderStatus < 5 && params.row.orderType != 4 ? 'inline-block' : 'none';
              const checkedDisplay = params.row.orderStatus == 6 ? 'inline-block' : 'none';

              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: assignOrderDisplay,
                    },
                    on: {
                      click: () => {
                        this.openAssignOrderModal(params.row.id);
                      }
                    }
                  },
                  "指派单"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: assignRefuseOrderDisplay
                    },
                    on: {
                      click: () => {
                        this.openAssignRefuseOrderModal(params.row.id);
                      }
                    }
                  },
                  "代派单"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: openElecDisplay
                    },
                    on: {
                      click: () => {
                        this.openElecModal(params.row);
                      }
                    }
                  },
                  "通电重试"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: finishedOrderDisplay
                    },
                    on: {
                      click: () => {
                        this.overCleanOrderModal.reason = '';
                        this.isAddNum = params.row.isConsumableGoods == 0 ? 'true':'false'  //判断是否需要补充/更换物品
                        const orderParams = {
                          id: params.row.id,
                          tips: `${Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss')}-${params.row.chainName}-${params.row.roomName}`,
                          roomId: params.row.roomId
                        };
                        this.currentOrder = params.row.id;
                        this.openOverOrderModal(orderParams);
                      }
                    }
                  },
                  "清洁结束"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      margin: "5px",
                      display: cancelOrderDisplay
                    },
                    on: {
                      click: () => {
                        this.openCancelOrderModal(params.row);
                      }
                    }
                  },
                  "取消清洁单"
                ),
                h(
                  "div",
                  {
                    style: {
                      margin: "5px",
                      display: checkedDisplay
                    },
                  },
                  "已核查"
                )
              ]);
            }
          }
        ],
        data: [],
        count: 0,
        page: 1,
        pageSize: 10,
        rules: {
          roomNo: [
            { required: false, trigger: "blur" },
            { type: "string", max: 255, message: "房号不能超过255字" }
          ],
          receiver: [
            { required: false, trigger: "blur" },
            { type: "string", max: 255, message: "接单人不能超过255字" }
          ],
          orderNo: [
            { validator: validateOrderList.orderNo, trigger: "blur" }
          ],
          xbedOrderNo: [
            { validator: validateOrderList.xbedOrderNo, trigger: "blur" }
          ]
        }
      },
      orderMessageListModal: {
        display: false,
        logsData: [],
      },
      // 人工结束清洁单原因
      overCleanReasonModal:{
        display:false,
        overReason:""
      },
      orderLeaveCommentsModal: {
        display: false,
        data: []
      },
      checkReportModal: {
        display: false,
        id: '',
        data: {}
      },
      createOrderModal: {
        display: false,
        cleanSource: 3,
        chainId: '',
        roomId: '',
        plan: '',
        cleanTypeId: '', //人工单类型
        itemType: '', // 项目类型
        goods: [],
        orderRemark: '',
        serviceDate: Moment().add(0.5, 'h').format('YYYY-MM-DD HH:mm'),
        xbedOrderNo: '',
        xbedCheckinId: '',
        rules: {
          chainId: [
            { validator: validateCreateOrder.chainId, trigger: 'change' }
          ],
          roomId: [
            { validator: validateCreateOrder.roomId, trigger: 'change' }
          ],
          plan: [
            { validator: validateCreateOrder.plan, trigger: 'change' }
          ],
          cleanTypeId: [
            { validator: validateCreateOrder.cleanTypeId, trigger: 'change' }
          ],
          serviceDate: [
            { validator: validateCreateOrder.serviceDate, trigger: 'change' }
          ],
          xbedOrderNo: [
            { required: true, message: "xbed订单编号不能为空", trigger: "blur" }
          ],
          xbedCheckinId: [
            { required: true, message: "xbed入住单号不能为空", trigger: "blur" }
          ],
          orderRemark: [
            {required: true, validator: validateCreateOrder.orderRemark, trigger: "blur" }
          ]
        }
      },
      assignOrderModal: {
        display: false,
        loading: false,
        id: '',
        account: '',
        data: [],
      },
      assignRefuseOrderModal: {
        display: false,
        loading: false,
        id: '',
        account: '',
        data: [],
      },
      cancelOrderModal: {
        display: false,
        id: '',
        chainName: '',
        roomNo: '',
        reasonType: '',
        reason: '',
        updateRoomStatus:false,
        rules: {
          reason: [
            { required: true, message: "取消原因不能为空", trigger: "blur" },
            { type: "string", max: 100, message: "取消原因不能超过100字" }
          ],
        }
      },
      overCleanOrderModal: {
        display: false,
        id: '',
        tips: '',
        reason:'',
        rules: {
          reason: [
            { required: true, message: "结束清洁单原因不能为空", trigger: "blur" },
            { type: "string", max: 500, message: "结束清洁单原因不能超过500字" }
          ],
        }
      },
      orderImgsModal: {
        display: false,
        id: '',
        imgs: []
      },
      replaceGoodsModal: {
        display: false,
        id: '',
        columns: [
          {
            title: "物品",
            key: "goodsName",
            align: "center",
            width: 150,
          },
          {
            title: "属性",
            key: "goodsAttribute",
            align: "center",
            width: 150,
          },
          {
            title: "补充数量",
            key: "cleanTypeName",
            align: "center",
            width: 150,
            render: (h, params) => {
              let num = 0;
              if (params.row.type === 3) {
                num = params.row.num
              }
              return h("div", {}, num);
            }
          },
          {
            title: "更换数量",
            key: "cleanTypeName",
            align: "center",
            width: 150,
            render: (h, params) => {
              let num = 0;
              if (params.row.type === 4) {
                num = params.row.num
              }

              return h("div", {}, num);
            }
          },
        ],
        data: []
      },
      // modal服务日期限制条件
      dateOptions: {
        disabledDate (date) {
          let today = Moment().startOf('day').valueOf();

          return date && date.valueOf() < today;
        }
      },
      // 创建日期限制条件
      disabledDateOptions: {
        disabledDate (date) {
          let tomorrow = Moment().add(0, 'day').startOf('day').valueOf();

          return date && date.valueOf() > tomorrow;
        }
      }
    }
  },
  computed: {
    chains: function() {
      // this.orderList.chainId = 'S00';
      if (this.orderList.city=='S00'&&this.orderList.hotspotId=='S00') {
        return this.chainList;
      } else if (this.orderList.city && this.orderList.hotspotId=='S00') {
        return this.chainList.filter(chain => {
          return chain.city == this.orderList.city;
        });
      } else if (this.orderList.city=='S00' && this.orderList.hotspotId) {
        return this.chainList.filter(chain => {
          return chain.parentId == this.orderList.hotspotId;
        });
      } else {
        return this.chainList.filter(chain => {
          let matchCities = chain.city == this.orderList.city;
          let matchHotSpot = chain.parentId == this.orderList.hotspotId;
          return matchCities && matchHotSpot;
        });
      }
    },
    hotspots: function() {
      this.orderList.hotspotId = 'S00';
      if (this.orderList.city=='S00') {
        return this.hotspotList;
      }
      return this.hotspotList.filter(hotSpot => {
        return hotSpot.city == this.orderList.city;
      });
    }
  },
  methods: {
    async refreshTodayData() {
      const resp = (await API.omsAPI[this.env].cleaner.findTodayData(this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "刷新今日清洁单数据失败",
          desc: resp.msg
        });
        return
      }

      this.todayData = resp
    },
    async querySelectList(params={}) {
      const resp = (await API.omsAPI[this.env].cleaner.querySelectListForCleanOrder(params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询城市/热点/门店失败",
          desc: resp.msg
        });
        return
      }

      this.cityList = resp.city;
      this.chainList = resp.chain;
      this.hotspotList = resp.hotspot;
    },
    async queryChainListForModal() {
      const resp = (await API.omsAPI[this.env].cleaner.queryChainListForCleanOrder(this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询门店列表失败",
          desc: resp.msg
        });
        return
      }

      this.chainListForModal = resp;
    },
    async queryRoomListForModal(id) {
      this.roomListForModal = [];
      if(!id){
        return
      }
      const resp = (await API.omsAPI[this.env].cleaner.queryRoomListForCleanOrder({ chainId: id }, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询房间列表失败",
          desc: resp.msg
        });
        return
      }

      this.roomListForModal = resp;
    },
    async queryCleanTypeList() {
      const params = {
        page: 1,
        pageSize: 999999
      }

      const resp = (await API.omsAPI[this.env].cleaner.queryListForCleanType(params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询清洁类型列表失败",
          desc: resp.msg
        });
        return
      }

      this.cleanTypeList = resp.content;
    },
    async queryPnsFeeCostList() {
      const page = 1; // 接口页数
      const pageSize = 999999; // 一次获取数据
      const resp = (await API.omsAPI[this.env].cleaner.queryPnsFeeCostList(page, pageSize, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询扣费项列表失败",
          desc: resp.msg
        });
        return
      }

      this.pnsFeeCostList = resp;
    },
    changeDateRange(dateRange, datePicker) {
      if (!dateRange[0]) {

        this.orderList[datePicker] = [];
      } else {
        let tranferDate = [
          Moment(dateRange[0]).format('YYYY-MM-DD'),
          Moment(dateRange[1]).format('YYYY-MM-DD')
        ]
        this.orderList[datePicker] = tranferDate;
      }
    },
    changeDate(date, datePicker) {
      this.createOrderModal[datePicker] = Moment(date).format('YYYY-MM-DD HH:mm');
    },
    queryCleanOrderListWithKeyword() {
      let validResult = false;
      this.$refs.orderListForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        return;
      }

      this.orderList.page = 1;
      this.queryCleanOrderList();
    },
    async queryCleanOrderList() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanOrder_query')) {
        return;
      }
      
      if (this.orderList.createDate.join('').length === 0 && this.orderList.serviceDate.join('').length === 0) {
        this.$Notice.error({
          title: "创建日期和服务日期必选至少其中一个日期"
        });
        return
      }

      this.orderList.loading = true;

      const resp = (await this.sendCleanOrderList(this.orderList, this.token, this.env)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询失败",
          desc: resp.msg
        });
        return
      }

      this.orderList.data = resp.content;
      this.orderList.count = resp.totalCount;
 
      this.orderList.loading = false;
    },
    sendCleanOrderList(orderList, token, env) {
      let params = {
        page: orderList.page,
        pageSize: orderList.pageSize,
      }

      if (this.orderList.createDate.join('').length > 0) {
        params.startDate = Moment(this.orderList.createDate[0]).format("YYYY-MM-DD");
        params.endDate = Moment(this.orderList.createDate[1]).format("YYYY-MM-DD");
      }

      if (this.orderList.serviceDate.join('').length > 0) {
        params.serviceDateStart = Moment(this.orderList.serviceDate[0]).format("YYYY-MM-DD");
        params.serviceDateEnd = Moment(this.orderList.serviceDate[1]).format("YYYY-MM-DD");
      }

      this.orderList.city !== 'S00'? params.city = this.orderList.city : '';
      this.orderList.chainId !== 'S00'? params.chainId = this.orderList.chainId : '';
      this.orderList.hotspotId !== 'S00'? params.hotspotId = this.orderList.hotspotId : '';
      this.orderList.xbedOrderNo? params.xbedOrderNo = this.orderList.xbedOrderNo : '';
      this.orderList.receiver? params.cleaner = this.orderList.receiver : '';
      this.orderList.orderNo? params.orderNo = this.orderList.orderNo : '';
      this.orderList.orderStatus !== 'S00'? params.orderStatus = this.orderList.orderStatus : '';
      this.orderList.roomNo? params.roomName = this.orderList.roomNo : '';
      this.orderList.orderType? params.orderType = this.orderList.orderType : '';
      this.orderList.cleanTypeId !== 'S00'  ? params.cleanTypeId = this.orderList.cleanTypeId : '';
      this.orderList.cleanSource !== '-1'  ? params.cleanSource = this.orderList.cleanSource : '';
      (this.orderList.priority !== 3) && (params.priority = this.orderList.priority);
      // this.orderList.cleanTypeId ? params.cleanTypeId = this.orderList.cleanTypeId : '';
      
      return API.omsAPI[env].cleaner.queryCleanOrderList(params, token);
    },
    changePage(pageIndex) {
      this.orderList.page = pageIndex;
      this.queryCleanOrderList();
    },
    changePageSize(pageSize) {
      this.orderList.page = 1;
      this.orderList.pageSize = pageSize;
      this.queryCleanOrderList();
    },
    async openOrderMessageListModal(id) {
      this.initOrderMessageListModal();

      const resp = (await API.omsAPI[this.env].cleaner.findCleanOrderLogs(id, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询清洁单失败",
          desc: resp.msg
        });
        return
      }

      this.orderMessageListModal.logsData = resp;
      this.orderMessageListModal.display = true;
      
    },
    closeOrderMessageListModal() {
      this.orderMessageListModal.display = false;
    },
    initOrderMessageListModal() {
      this.orderMessageListModal = Object.assign({}, this.orderMessageListModal, {
        cleanOrderResult: {},
        cleanOrderTempResult: {},
        cleanRecommendResult: {}
      })
    },
    async openOrderLeaveCommentsModal(id) {
      this.initOrderLeaveCommentsModal();

      const resp = (await API.omsAPI[this.env].cleaner.queryCleanOrderMessageList(id, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查看留言失败",
          desc: resp.msg
        });
        return
      }

      for (let i=0; i<resp.length; i++) {
        const createDate = Moment(resp[i].createDate).format('YYYY-MM-DD HH:mm:ss')
        this.orderLeaveCommentsModal.data.push({
          time: createDate,
          content: resp[i].message
        })
      }

      this.orderLeaveCommentsModal.display = true;
      
    },
    closeOrderLeaveCommentsModal() {
      this.orderLeaveCommentsModal.display = false;
    },
    initOrderLeaveCommentsModal() {
      this.orderLeaveCommentsModal.data = [];
    },
    async openCheckReportModal(id) {
      this.initCheckReportModal(id);

      const resp = (await API.omsAPI[this.env].cleaner.findCheckDetailForCleanOrder(id, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查看审查情况失败",
          desc: resp.msg
        });
        return
      }

      this.checkReportModal.data = resp;

      this.checkReportModal.display = true;
    },
    closeCheckReportModal() {
      this.checkReportModal.display = false;
    },
    initCheckReportModal(id) {
      this.checkReportModal.id = id;
      this.checkReportModal.data = {};
    },
    openCreateOrderModal() {
      this.initCreateOrderModal();
      this.createOrderModal.display = true;
    },
    initCreateOrderModal() {
      this.createOrderModal = Object.assign(this.createOrderModal, {
        chainId: '',
        roomId: '',
        plan: '',
        itemType: '',
        serviceDate: Moment().add(0.5, 'h').format('YYYY-MM-DD HH:mm'),
        xbedOrderNo: '',
        xbedCheckinId: '',
        orderRemark: ''
      })
    },
    changeChainForModal(id) {
      this.createOrderModal.roomId = '';
      this.itemDetailGroup = {};
      this.queryRoomListForModal(id);
    },
    // 查询物品设置
    async findItemType() {
      const { plan, roomId } = this.createOrderModal;

      this.itemDetailGroup = {};

      this.createOrderModal.goods = [];

      // 如果没有选择房间id且没有选择触发方案，不调用
      if (!roomId || !plan) {
        return;
      }

      const resp = (await API.omsAPI[this.env].cleaner.findItemType(roomId, plan, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询物品设置失败",
          desc: resp.msg
        });
        return
      }

      if (resp.itemType===2) {

        resp.itemDetailGroup = ['1', '2', '3'];

      } else if (resp.itemType===1 && resp.itemDetail) {

        resp.itemDetailGroup = resp.itemDetail.split(',');
        
      } else {

        resp.itemDetailGroup = [];
      }

      for (let i=0; i<resp.itemDetailGroup.length; i++) {
        const item = resp.itemDetailGroup[i];
        const itemLabel = ['', '更换床品', '更换毛巾', '补充易耗品'][+item];

        this.itemDetailGroup[+item] = itemLabel;

        if (resp.itemType === 1) {
          this.createOrderModal.goods.push(item);
        }
      }

      this.createOrderModal.itemType = resp.itemType;

      this.itemDetailGroup = Object.assign({}, this.itemDetailGroup);

    },
    async preCreateOrder() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanOrder_add')) {
        this.$refs.createOrderModal.buttonLoading = false;
        return;
      }

      let validResult = false;
      this.$refs.createOrderModalForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.createOrderModal.buttonLoading = false;
        return;
      }

      let params = {
        plan: this.createOrderModal.plan,
        roomId: this.createOrderModal.roomId,
        cleanSource: this.createOrderModal.cleanSource,
        orderRemark: this.createOrderModal.orderRemark,
        createName: this.username,
        serviceDate: Moment(this.createOrderModal.serviceDate).format('YYYY-MM-DD HH:mm:ss'),
      }

      if (this.createOrderModal.plan === 1 || this.createOrderModal.plan === 2 || 
          (this.createOrderModal.plan === 9 && this.createOrderModal.cleanTypeId == 19)) {
        params = Object.assign(params, {
          xbedCheckinId: this.createOrderModal.xbedCheckinId,
          xbedOrderNo: this.createOrderModal.xbedOrderNo
        })
      }

      if (this.createOrderModal.plan === 9) {
        params = Object.assign(params, {
          cleanTypeId: this.createOrderModal.cleanTypeId,
          cleanTypeName: this.createOrderModal.cleanType==19?'物品补充单':'维修单',
        })
      }

      if (this.createOrderModal.goods.length > 0) {
        params.itemDetail = this.createOrderModal.goods.join(',');
      }

      const resp = (await API.omsAPI[this.env].cleaner.addCleanOrder(params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "人工建单失败",
          desc: resp.msg
        });
        this.$refs.createOrderModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "人工建单成功"
      });
      this.queryCleanOrderList();
      this.createOrderModal.display = false;
    },
    // 选择接单人员
    async openAssignOrderModal(id) {
      this.assignOrderModal = {
        display: true,
        loading: false,
        id: id,
        account: '',
        data: [],
        queryName:'',
        queryMobile:'',
        totalPage:0
      }
    },
    async chooseCleaner(params){
      const resp = (await API.omsAPI[this.env].cleaner.cleanerAccountAcceptData(params,this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "查询接单人员列表失败",
          desc: resp.msg
        });
        return
      }
      this.assignOrderModal.data = resp.content || [];
      this.assignOrderModal.totalPage = resp.totalCount;
      this.assignOrderModal.loading = false;
    },
    changeAssignOrderAccount(account) {
      this.assignOrderModal.account = account;
    },
    // 指派单
    async preAssignOrder() {
      this.queryCleanOrderList();
      this.assignOrderModal.display = false;
    },
    async openAssignRefuseOrderModal(id='') {
      this.initAssignRefuseOrderModal(id);

      this.assignRefuseOrderModal.display = true;

      this.assignRefuseOrderModal.loading = true;

      const resp = (await API.omsAPI[this.env].cleaner.findHotSpotCleaner(this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询热点工作人员列表失败",
          desc: resp.msg
        });
        return
      }

      this.assignRefuseOrderModal.data = resp;

      this.assignRefuseOrderModal.loading = false;
    },
    initAssignRefuseOrderModal(id) {
      this.assignRefuseOrderModal = Object.assign(this.assignOrderModal, {
        id,
        account: '',
        data: [],
      })
    },
    changeAssignRefuseOrderAccount(account) {
      this.assignRefuseOrderModal.account = account;
    },
    async preAssignRefuseOrder() {
      if (!this.assignRefuseOrderModal.account) {
        this.$Notice.error({
          title: "请指定热点工作人员"
        });
        return
      }

      const resp = (await API.omsAPI[this.env].cleaner.assignCleanOrder(this.assignRefuseOrderModal.id, this.assignRefuseOrderModal.account, this.username, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "代派单失败",
          desc: resp.msg
        });
        this.$refs.assignRefuseOrderModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "代派单成功"
      });
      this.queryCleanOrderList();
      this.assignRefuseOrderModal.display = false;
    },
    openCancelOrderModal(order) {
      this.initCancelOrderModal(order);
      
      this.cancelOrderModal.display = true;
    },
    initCancelOrderModal(order) {
      this.cancelOrderModal = Object.assign(this.cancelOrderModal, {
        id: order.id,
        chainName: order.chainName,
        roomNo: order.roomName,
        reasonType: 4,
        reason: '',
        updateRoomStatus: false
      })
    },
    openElecModal(order) {
      this.$Modal.confirm({
        title: '消息提醒',
        content: '确认此清洁单现在给房间通电吗？',
        onOk: () => {
          this.preOpenElec(order)
        }
      })

    },
    changeReason(labelInValue) {
      if (labelInValue.value !== 4) {
        this.openElecModal.reason = labelInValue.label;
      }
    },
    async preCancelCleanOrder() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanOrder_cancelCleanOrder')) {
        this.$refs.cancelOrderModal.buttonLoading = false;
        return;
      }

      let validResult = false;
      this.$refs.cancelOrderModalForm.validate(valid => {
        validResult = valid;
      })
      if (!validResult) {
        this.$refs.cancelOrderModal.buttonLoading = false;
        return;
      }
      this.cancelOrderModal.updateRoomStatusSwitch=this.cancelOrderModal.updateRoomStatus === false?'0':'1'
      const resp = (await API.omsAPI[this.env].cleaner.cancelCleanOrder((this.cancelOrderModal.reason).replace(/(^\s*)|(\s*$)/g, ""), this.cancelOrderModal.id, this.username,this.cancelOrderModal.updateRoomStatusSwitch, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "取消失败",
          desc: resp.msg
        });
        this.$refs.cancelOrderModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "取消成功"
      });
      this.queryCleanOrderList();
      this.cancelOrderModal.display = false;

    },
    checkHasPermission( name ) {
      if ( !Utils.hasPermission( name ) ) {
        this.$Notice.error( {
          title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
        } );

        return false;
      }
      return true;
    },
    async preOpenElec(order) {
      if (!this.checkHasPermission('oms_lock_openRoomLock.do')) {
        // this.$refs.openElecModal.buttonLoading = false;
        return;
      }
      var statusType = order.cleanTypeName == '维修单' ? 2 : 1
      var endTime = Moment().add(statusType == 1 ? 45 : 90, 'minutes').format('YYYY-MM-DD HH:mm:ss')
      var params = {
          reson: '清洁单通电',
          cleanOrderNo: order.orderNo,
          orderNo:  order.xbedOrderNo,
          checkinId: order.xbedCheckinId,
          remark: "【OMS】清洁单通电",
          roomId:  order.roomId,
          operator:'【OMS】' + this.username,
          endTime: endTime,
          powerStatus: 1,
          statusType: statusType
      }
      var env = Utils.findFromLocalStorage("env", "dev");
      API.omsAPI[env].clientServer.applyElec(params, {
        'isForm': true,
        'x-ca-stage': Utils.aliHeaderEnv(this.env), 
        'Authorization': Utils.findFromLocalStorage("Author-token"),
      }).then((res) => {
          var data = res.data;
          if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200) {
            this.$Notice.error({
              title:data.msg
            });
          } else {
            this.$Notice.success({
              title: "操作成功"
            });
          }
      })
    },
    openOverOrderModal(order) {
      this.initOverOrderModal(order);
      this.goodsAdd = []; //清数组缓存
      this.overCleanOrderModal.display = true;
      this.getMpdalList(order);
    },
    // 获取房间易耗品和布草列表
    async getMpdalList(order){
      let params = {
        cleanOrderId : order.id,
        goodsAttribute :"易耗品,布草",
        roomId : order.roomId
      }; 
      this.isSpin = true;
      const resp = (await API.omsAPI[this.env].cleaner.queryRoomGoodsList(params,this.token)).data;
      this.isSpin = false;
      this.goodsAdd = resp
    },
    // 录入物品更换补充数据
    async submitOverCleanOrder(){
      let goods = this.goodsAdd || [];
      const goodsDamageList = [];
      if (typeof(goods) === 'object' && goods.length > 0) {
        goods.forEach(good =>{
          goodsDamageList.push({
            cleanOrderId:this.currentOrder,
            goodsId:good.goodsId,
            goodsName:good.goodsName,
            type:good.goodsAttribute == 1 ? 3 : 4,
            num:good.goodsNum,
            createName:this.username
          })
        })
      }
      let validResult = false;
      this.$refs.overCleanOrderModalForm.validate(valid => {
        validResult = valid;
      })
      if (!validResult) {
        this.$refs.overCleanOrderModal.buttonLoading = false;
        return;
      }
      const resp = (await API.omsAPI[this.env].cleaner.postAddDamageGoods(this.currentOrder,JSON.stringify(goodsDamageList),this.token)).data;
      if (resp.retCode) {
          this.$Notice.error({
          title: "结束清洁单数据录入失败",
          desc: resp.msg
        });
        this.$refs.overCleanOrderModal.buttonLoading = false;
        return
      }else{
        this.$Notice.success({
          title: "结束清洁单数据录入成功"
        });
      }
      // 如果补充数据成功 结束清洁单
      this.preOverCleanOrder();
      this.overCleanOrderModal.display = false;
    },
    initOverOrderModal(order) {
      this.overCleanOrderModal = Object.assign(this.overCleanOrderModal, {
        id: order.id,
        tips: order.tips
      })
    },
    async preOverCleanOrder() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanOrder_overCleanOrder')) {
        this.$refs.overCleanOrderModal.buttonLoading = false;
        return;
      }
      let validResult = false;
      this.$refs.overCleanOrderModalForm.validate(valid => {
        validResult = valid;
      })
      if (!validResult) {
        this.$refs.overCleanOrderModal.buttonLoading = false;
        return;
      }
      const resp = (await API.omsAPI[this.env].cleaner.overCleanOrder(this.username, this.overCleanOrderModal.id, this.overCleanOrderModal.reason.trim(),this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "结束清洁单失败",
          desc: resp.msg
        });
        this.$refs.overCleanOrderModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "结束清洁单成功"
      });
      this.queryCleanOrderList();
      this.overCleanOrderModal.display = false;
    },
    // 人工结束清洁单
    closeOverCleanReasonModal(){
     this.overCleanReasonModal.display = false;
    },
    async openOrderImgsModal(payload) {
      this.initOrderImgsModal(payload);

      const resp = (await API.omsAPI[this.env].cleaner.findImgsByCleanOrderId(this.orderImgsModal.id, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查看照片失败",
          desc: resp.msg
        });
        return
      }

      this.orderImgsModal.imgs = resp;

      this.$nextTick(() => {
        this.$refs.orderImgs.renderImgs();
        this.orderImgsModal.display = true;
      })
    },
    initOrderImgsModal(payload) {
      this.orderImgsModal = Object.assign(this.orderImgsModal, {
        id: '',
        imgs: [],
      }, payload);
    },
    closeOrderImgsModal() {
      this.orderImgsModal.display = false;
    },
    async openReplaceGoodsModal(id='') {
      this.initReplaceGoodsModal(id);

      const resp = (await API.omsAPI[this.env].cleaner.findConsumableForCleanOrder(this.replaceGoodsModal.id, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "物品补充更换失败",
          desc: resp.msg
        });
        return
      }

      this.replaceGoodsModal.data = resp;

      this.replaceGoodsModal.display = true;
    },
    initReplaceGoodsModal(id) {
      this.replaceGoodsModal = Object.assign({}, this.replaceGoodsModal, {
        id,
        data: []
      })
    },
    closeReplaceGoodsModal() {
      this.replaceGoodsModal.display = false;
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },

    selectCleanTypeFn() {
      this.createOrderModal.xbedCheckinId = ''
      this.createOrderModal.xbedOrderNo = ''
      this.createOrderModal = this.createOrderModal
    }
  },
  components: {
    'order-logs': OrderLogs,
    'account-table': AccountTable,
    'leave-comments': LeaveComments,
    'check-report': CheckReport,
    'order-imgs': OrderImgs,
  }
}
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}

.tips-info {
  color: #ed3f14
}

.refresh-order{
  width: 1200px;
  margin: 15px 0;
  >span{
    margin-right: 100px;
  }
}
.cleanTable{
  width: 700px;
  border:1px solid #eee;
  margin: 0 auto;
}
.top:nth-child(2n+1){
  background: #F7F7F7;
}
.top{
  text-align: center;
  height: 35px;
  line-height: 35px;
  vertical-align:middle;
}
.tipsMessage{
  width: 700px;
  margin: 0 auto;
  padding: 15px 5px;
}
</style>





// WEBPACK FOOTER //
// src/pages/cleaner/order-list/index.vue